import "./DrawerNavbar.css";

import { BackIcon, CloseIcon } from "../Icons";
import { Box, SxProps, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { FC, ReactNode } from "react";

interface IDrawerButtonProps {
  onClose?: () => void;
  onBack?: () => void;
  text?: string;
  children?: ReactNode;
  sx?: SxProps;
  drawerNavbarStyle?: SxProps
  ifIconClose?: boolean;
}

const DrawerNavbar: FC<IDrawerButtonProps> = ({ onClose, onBack, sx, children, drawerNavbarStyle, text,
  ifIconClose }) => {
  const theme = useTheme();
  const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));

  return <Box sx={drawerNavbarStyle} className="drawerNavbarContainer">
    <Box sx={{ display: "flex", pb: "5px", alignItems: "center", flexDirection: "row" }}>
      {text && <Box className="buttonContainerStyle text" sx={{ width: "75%", textTransform: "none" }}>
        <Typography variant="body1" sx={{
          fontWeight: "400",
          textTransform: "none",
          width: "90%", textAlign: "center", margin: "0 auto",
          fontSize: mobileSize? "16px": "20px", whiteSpace: "nowrap", overflow: "hidden", lineHeight: "30px",
          textOverflow: text.length > 20 ? "ellipsis" : "clip" }}>
          {text}</Typography>
      </Box>
      }
      <Box className="buttonContainerStyle avatarDrawer">
        {children}
      </Box>
      {onClose && (
        <Box
          sx={sx}
          className="buttonContainerStyle link "
          onClick={onClose}
        >
          <Box sx={{ "mr": "0.5rem", "svg": { display: "grid" } }}>
            <CloseIcon />
          </Box>
          <Typography variant="body1" sx={{ fontWeight: "400" }}>
            Close
          </Typography>
        </Box>
      )
      }
      {onBack && (
        <Box
          sx={sx}
          className="buttonContainerStyle link backbtn"
          onClick={onBack}
        >
          <Box sx={{ mr: "0.5rem" }}>
            {!ifIconClose ? <BackIcon /> :
              <CloseIcon />}
          </Box>
        </Box>
      )
      }
    </Box>

  </Box>;
};

export default DrawerNavbar;
